import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpRequest } from '@angular/common/http'; 

import { Observable, throwError } from 'rxjs';
import { GlobalService } from '../services/global.service';
  @Injectable({
    providedIn: 'root'
  })
export class DocumentaryService {
  handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.error.message);
    } else {
      console.log("Error status: ",error.status);
      
      if(error.status == 0){
        console.error("IMPOSSIBILE CONNETTERSI AL SERVER");
      }
      else{
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
      }
    }
    return throwError('Something bad happened; please try again later.');
  };
  token: string;
  constructor(
    private globalService: GlobalService,
    private http: HttpClient
  ) { 
    this.token = this.globalService.getToken();
  }

  getRoot(token){
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };
    return this.http.get<any>(this.globalService.getRoot, httpOptions)
  }

  getFolderContent(token, id)
  {
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };
    return this.http.get<any>(this.globalService.getFolderContent(id), httpOptions)
  }

  newFolder(token, parentF, folderN){
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };
    return this.http.get<any>(this.globalService.newFolder(parentF, folderN), httpOptions)
  }

  delFolder(token, id){
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };
    return this.http.delete<any>(this.globalService.deleteFolder(id), httpOptions)
  }

  updateName(token, id, obj){
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };
    return this.http.put<any>(this.globalService.updateFolderName(id), obj, httpOptions)
  }

  uploadFile(token, folder, formData){
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': token
      })
    };
    return this.http.post<any>(this.globalService.uploadFile(folder), formData, httpOptions)
  }


  getContent(token, id): Observable<Blob> {
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': token
      }),
      _responseType: "blob",
      get responseType() {
        return this._responseType;
      },
      set responseType(value) {
        this._responseType = value;
      },
      
    };
    return this.http.get<any>(this.globalService.getContent(id), httpOptions)
  }

}